const fallbackRandomUUID = () =>
  `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

export const safeRandomUUID = () => {
  try {
    return globalThis.crypto?.randomUUID?.() ?? fallbackRandomUUID();
  } catch {
    return fallbackRandomUUID();
  }
};

export default safeRandomUUID;
